// extracted by mini-css-extract-plugin
export default {"button":"xp-z","reviewSort":"yp-z"};